import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import P5Wrapper from 'react-p5-wrapper';
import sketch from './sketches/simulation';
import Menu from './menu/Menu';
import Box from '@material-ui/core/Box';
import MyChart from './chart/Chart'
import Divider from '@material-ui/core/Divider';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: {
        amount: 200,
        percent1: 80,
        speed1: 2,
        percent2: 20,
        speed2: 5,
        time: 14,
        infectionRate: 50,
        mortality: 5,
      },
      resolutions: {
        width: 0,
        height: 0,
        chartWidth: 0,
        chartHeight: 0,
        menuWidth: 0,
        menuHeight: 0,
        canvasWidth: 0,
        canvasHeight: 0,
        legendWidth: 0,
        legendHeight: 0,
      }, started: false
    }
  }

  /**
     * Calculate & Update state of new dimensions
     */
  updateDimensions() {

    let width = window.innerWidth;
    let height = window.innerHeight;

    let menuWidth = 255;
    let chartHeight = 205;

    let canvasWidth = window.innerWidth - menuWidth;
    let canvasHeight = window.innerHeight - chartHeight;

    let chartWidth = window.innerWidth - menuWidth;

    let menuHeight = window.innerHeight;
    App.canvasHeight = canvasHeight; App.canvasWidth = canvasWidth;
    this.setState({
      resolutions: {
        width: width,
        height: height,
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        menuWidth: menuWidth,
        menuHeight: menuHeight,
        canvasWidth: canvasWidth,
        canvasHeight: canvasHeight,
      }
    }, () => {
      App.canvasHeight = canvasHeight; App.canvasWidth = canvasWidth;
      this.refs.menu.setState({ height: menuHeight, width: menuWidth });
      this.refs.chart.setState({ height: chartHeight, width: chartWidth });
    });
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  updateValue = (newValue) => {
    this.setState({ settings: newValue }, () => {
    });
    this.setState({ started: false }, () => { this.refs.chart.setDefault(this.state.settings) });
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ started: true }, () => { });
    this.setState({ addData: this.refs.chart.addData }, () => { });
    this.setState({ clearData: this.refs.chart.clear }, () => { });
  }

  render() {

    return (
      <div className="App">
        <body style={{ overflow: 'hidden' }}>
          <Box flexDirection="row" style={{ overflow: 'hidden' }}>
            <Box margin="auto" position="absolute" top={0} left={this.state.resolutions.menuWidth} onClick={this.handleClick} style={{ backgroundColor: 'white', overflow: 'none' }} >
              <P5Wrapper sketch={sketch} settings={this.state.settings} started={this.state.started} addData={this.state.addData} clearData={this.state.clearData} />
            </Box>
            <Box position="absolute" top={0} left={0} height={window.innerHeight} style={{ overflow: 'hidden' }}>
              <Menu ref="menu" settings={this.state.settings} valueChanged={this.updateValue} height={window.innerHeight} />
            </Box>
            <Box position="absolute" top={window.innerHeight - 205} left={this.state.resolutions.menuWidth} style={{ overflow: 'hidden' }}>
              <Divider />
              <MyChart ref="chart" settings={this.state.settings} width={this.state.resolutions.chartWidth} height={this.state.resolutions.chartHeight} />
            </Box>
          </Box>
        </body>
      </div >
    );
  }
}
ReactDOM.render(
  <App />,
  document.getElementById('root')
);

export default App;
